"use client";
import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { memo as t } from "react";
import a from "../components/Icon/SvgIcon.js";
const e = (i) => /* @__PURE__ */ o(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...i,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.246 4.243 19.752 19.75a.5.5 0 0 1 0 .707l-.509.509a.5.5 0 0 1-.707 0l-2.686-2.687a10.6 10.6 0 0 1-3.852.721c-4.43 0-8.238-2.71-9.918-6.6a1 1 0 0 1 0-.8 11.1 11.1 0 0 1 3.022-4.068L3.03 5.459a.5.5 0 0 1 0-.707l.51-.51a.5.5 0 0 1 .707 0Zm3.597 6.03a4.5 4.5 0 0 0 5.884 5.884l-1.423-1.423a2.75 2.75 0 0 1-3.037-3.037z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M21.915 12.4a11.1 11.1 0 0 1-3.022 4.069l-2.738-2.738a4.5 4.5 0 0 0-5.886-5.886L8.145 5.721a10.6 10.6 0 0 1 3.853-.72c4.429 0 8.237 2.71 9.917 6.6.11.25.11.55 0 .8Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.733 12.309a2.75 2.75 0 0 0-3.042-3.041z"
        }
      )
    ]
  }
), m = t(e);
export {
  m as VisibilityHide,
  m as default
};
